import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {Home} from './pages/home/home';
import {Shows} from './pages/shows/shows';
import {EventDetails} from './pages/event-details/event-details';
import {Results} from './pages/results/results';
import {News} from './pages/news/news';
import {Membership} from './pages/membership/membership';
import {Rulebook} from './pages/rulebook/rulebook';
import {About} from './pages/about/about';
import {LayoutComponent} from './pages/auth/layout/layout.component';
import {RegisterUserComponent} from './pages/auth/register-user/register-user.component';
import {LoginComponent} from './pages/auth/login/login.component';
import {ForgotPassordComponent} from './pages/auth/forgot-passord/forgot-passord.component';
import {ResetPasswordComponent} from './pages/auth/reset-password/reset-password.component';
import {VerifyEmail} from './pages/auth/verify-email/verify-email';
import {UserProfile} from './pages/user-profile/user-profile';
import {AuthGuard} from './@core/guards/auth.guard';
import {CompanyProfile} from './pages/company-profile/company-profile';
import {AddEvent} from './pages/company-profile/components/company-profile-events/components/add-event/add-event';
import {
  ManageEvent
} from './pages/company-profile/components/company-profile-events/components/manage-event/manage-event';
import {EventRegistrationComponent} from './pages/event-registration/event-registration';

const routes: Routes = [
  { path: '', component: Home, pathMatch: 'full'},
  { path: 'shows', component: Shows, pathMatch: 'full'},
  { path: 'event-details/:id', component: EventDetails },
  { path: 'event-registration/:eventId', component: EventRegistrationComponent, canActivate: [AuthGuard] },
  { path: 'results', component: Results, pathMatch: 'full'},
  { path: 'news', component: News, pathMatch: 'full'},
  { path: 'membership', component: Membership, pathMatch: 'full'},
  { path: 'rulebook', component: Rulebook, pathMatch: 'full'},
  { path: 'about', component: About, pathMatch: 'full'},
  { path: 'auth', component: LayoutComponent, children: [
      { path: 'login', component: LoginComponent },
      { path: 'register-user', component: RegisterUserComponent},
      { path: 'verify-email', component: VerifyEmail},
      { path: 'forgot-password', component: ForgotPassordComponent},
      { path: 'reset-password', component: ResetPasswordComponent}
    ]
  },
  { path: 'user-profile', component: UserProfile, canActivate: [AuthGuard] },
  { path: 'company-profile', component: CompanyProfile, canActivate: [AuthGuard] },
  { path: 'company-profile/add-event', component: AddEvent, canActivate: [AuthGuard] },
  { path: 'company-profile/manage-event/:id', component: ManageEvent, canActivate: [AuthGuard] },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
